import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComments2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.58 13.36C16.7 12.24 17.4 10.84 17.4 9.3C17.4 5.8 13.97 3 9.7 3C5.43 3 2 5.8 2 9.3C2 12.8 5.43 15.6 9.7 15.6C10.47 15.6 11.17 15.53 11.87 15.32L16 17L15.58 13.36Z",
			stroke: "#42229C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58301 6.5V12.3333",
			stroke: "#42229C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66699 9.41675H12.5003",
			stroke: "#42229C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgComments2;
